import { Box, Hidden, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import { ReactComponent as SGILogo } from './sgi-logo.svg';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        padding: ${theme.spacing(0, 1, 0, 0)};
        display: flex;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const LogoTextWrapper = styled(Box)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
`
);

const LogoText = styled(Box)(
  ({ theme }) => `
        font-size: 21px;
        font-weight: ${theme.typography.fontWeightBold};
`
);

function Logo() {
  return (
    <LogoWrapper to="/">
      <Grid container
        spacing={0}
        direction="row"
        alignItems="center"
        justifyContent="center"
        >
        <SGILogo style={{ height: "20px" }} />
        <Hidden smDown>
          <LogoTextWrapper>
            <LogoText>DevOps Portal</LogoText>
          </LogoTextWrapper>
        </Hidden>
      </Grid>
    </LogoWrapper>
  );
}

export default Logo;
